module.exports = __webpack_public_path__ + "img/420.39bd789e.jpg";